import snippets from './snippets';
import {customDuck} from 'utils/duckify';

import { actionize, apiAction, apiFetch, stringParams } from 'utils';

const duck = snippets('webSnippets');

let types = {
  RENDER_SNIPPET: null,
  RENDER_SUCCESS: null,
  RENDER_ERROR: null,
};
types = actionize(types, (action) => `schooladmin/webSnippets/${action}`);

const renderedSnippet = (canonical_name, contact_id) => customDuck(duck, {
  load: () => apiAction(
    types.RENDER_SNIPPET, types.RENDER_SUCCESS, types.RENDER_ERROR,
    (state) => apiFetch.get(state, `${duck.config.entityApiPath(canonical_name)}/rendered`, {query: stringParams({contact_id})}),
    {stateKey: `${canonical_name}_${contact_id}`},
    { }
  ),
  read: (state) => state.webSnippets.renderedSnippets[`${canonical_name}_${contact_id}`] || {value: null, meta: {pending: true}}
});

const renderedSnippetsReducer = (state = {}, action) => {
  if (action.type === types.RENDER_SNIPPET) {
    return {
      ...state,
      [action.stateKey]: {
        ...state[action.stateKey],
        value: null,
        meta: {
          fetching: true
        }
      }
    }
  }
  else if (action.type === types.RENDER_SUCCESS) {
    return {
      ...state,
      [action.stateKey]: {
        value: action.payload.result || null,
        meta: {
          ready: true,
        }
      }
    }
  }
  else if (action.type === types.RENDER_ERROR) {
    return {
      ...state,
      [action.stateKey]: {
        value: null,
        meta:{
          error: true
        }
      }
    }
  }

  return state;
};

const initialState = {
  ...duck.initialState,
  renderedSnippets: {}
};

const reducer = (state=initialState, action) => ({
  ...duck.reducer(state, action),
  renderedSnippets: renderedSnippetsReducer(state.renderedSnippets, action)
});

export default reducer;
export const entity= {
  ...duck,
  reducer
};

export {
  renderedSnippet
};
